import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { RULES_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_RULES_LIST = '_LOAD_RULES_LIST';
export const CREATE_RULES = '_CREATE_RULES';
export const LOAD_RULES_BY_ID = '_LOAD_RULES_BY_ID';
export const EDIT_RULES_BY_ID = '_EDIT_RULES_BY_ID';
export const DELETE_RULES = '_DELETE_RULES';

export const loadRulesList = createDeferredAction(RULES_MODULE + LOAD_RULES_LIST);
export const loadRulesListBegin = createDeferredAction(RULES_MODULE + LOAD_RULES_LIST + BEGIN);
export const loadRulesListSuccessful = createAction(RULES_MODULE + LOAD_RULES_LIST + SUCCESSFUL);
export const loadRulesListFailed = createAction(RULES_MODULE + LOAD_RULES_LIST + FAILED);

export const createRules = createDeferredAction(RULES_MODULE + CREATE_RULES);
export const createRulesSuccessful = createAction(RULES_MODULE + CREATE_RULES + SUCCESSFUL);
export const createRulesFailed = createAction(RULES_MODULE + CREATE_RULES + FAILED);

export const loadRulesById = createDeferredAction(RULES_MODULE + LOAD_RULES_BY_ID);
export const loadRulesByIdSuccessful = createAction(RULES_MODULE + LOAD_RULES_BY_ID + SUCCESSFUL);
export const loadRulesByIdFailed = createAction(RULES_MODULE + LOAD_RULES_BY_ID + FAILED);
export const loadRulesByIdClear = createDeferredAction(RULES_MODULE + LOAD_RULES_BY_ID + CLEAR);

export const editRulesById = createDeferredAction(RULES_MODULE + EDIT_RULES_BY_ID);
export const editRulesByIdSuccessful = createAction(RULES_MODULE + EDIT_RULES_BY_ID + SUCCESSFUL);
export const editRulesByIdFailed = createAction(RULES_MODULE + EDIT_RULES_BY_ID + FAILED);

export const deleteRules = createDeferredAction(RULES_MODULE + DELETE_RULES);
export const deleteRulesSuccessful = createAction(RULES_MODULE + DELETE_RULES + SUCCESSFUL);
export const deleteRulesFailed = createAction(RULES_MODULE + DELETE_RULES + FAILED);
